// extracted by mini-css-extract-plugin
export default {"entry":"_1HErB _16lPk","label":"oJqDB","tagSelectorLabelHidden":"_3XvK2"};